import React from 'react';
import { useT } from '../../i18n/LanguageContext';
import { usd } from './cashMoney';
import { CASH_DEPOSIT_METHODS, cashDepositMethod, depositStateLabel } from './cashDepositContract';

export default function CashDepositHistory({ history, page, busy, onPage }) {
  const t = useT();
  return (
    <details className="me-cash-details">
      <summary>{t('Funding requests')}</summary>
      <p>{t('Requests to add money. Pending requests do not increase your balance.')}</p>
      {!history ? (
        <p>{t('Funding requests are unavailable.')}</p>
      ) : !history.items.length ? (
        <p>{t('No cash funding requests yet.')}</p>
      ) : (
        <>
          <div className="me-cash-scroll">
            <table>
              <caption className="sr-only">{t('Cash funding requests and payment status')}</caption>
              <thead>
                <tr>
                  <th scope="col">{t('Date')}</th>
                  <th scope="col">{t('Method')}</th>
                  <th scope="col">{t('Status')}</th>
                  <th scope="col">{t('Amount')}</th>
                </tr>
              </thead>
              <tbody>
                {history.items.map((row) => (
                  <tr key={row._id}>
                    <td>{new Date(row.createdAt).toLocaleDateString('en-US')}</td>
                    <td>{t(CASH_DEPOSIT_METHODS[cashDepositMethod(row)])}</td>
                    <td>{t(depositStateLabel(row))}</td>
                    <td>{usd(row.amountCents)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {history.total > 10 && (
            <div className="me-cash-actions">
              <button type="button" disabled={busy || page === 1} onClick={() => onPage(page - 1)}>
                {t('Previous')}
              </button>
              <span>
                {t('Page {page} of {pages}', { page, pages: Math.ceil(history.total / 10) })}
              </span>
              <button
                type="button"
                disabled={busy || page * 10 >= history.total}
                onClick={() => onPage(page + 1)}
              >
                {t('Next')}
              </button>
            </div>
          )}
        </>
      )}
    </details>
  );
}
